module.exports = __webpack_public_path__ + "img/total-trial-class.cedbe306.svg";